import { combineReducers } from "redux";

const defaultActiveCallsTab = 'all';
const activeCallsTab = (state = defaultActiveCallsTab, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_CALLS_TAB':
      return action.tab;
    default:
      return state;
  }
};

const defaultLoadingIncomingCalls = false;
const loadingIncomingCalls = (state = defaultLoadingIncomingCalls, action) => {
  switch (action.type) {
    case 'GET_INCOMING_CALLS':
      return true;
    case 'GET_INCOMING_CALLS_SUCCESS':
    case 'GET_INCOMING_CALLS_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultLoadingOutgoingCalls = false;
const loadingOutgoingCalls = (state = defaultLoadingOutgoingCalls, action) => {
  switch (action.type) {
    case 'GET_OUTGOING_CALLS':
      return true;
    case 'GET_OUTGOING_CALLS_SUCCESS':
    case 'GET_OUTGOING_CALLS_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultOutgoingCallsFilterCompany = {};
const outgoingCallsFilterCompany = (state = defaultOutgoingCallsFilterCompany, action) => {
  switch (action.type) {
    case 'OUTGOING_CALLS_FILTER_COMPANY':
      return action.filter
    default:
      return state;
  }
};

const defaultIncomingCallsFilterCompany = {};
const incomingCallsFilterCompany = (state = defaultIncomingCallsFilterCompany, action) => {
  switch (action.type) {
    case 'INCOMING_CALLS_FILTER_COMPANY':
      return action.filter
    default:
      return state;
  }
};

export default combineReducers({
  activeCallsTab,
  loadingIncomingCalls,
  loadingOutgoingCalls,
  outgoingCallsFilterCompany,
  incomingCallsFilterCompany
});
